import {AfterContentInit, Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";

@Component({
  selector: 'cc-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class SideBarComponent implements AfterContentInit {


  // filterToolbarClass: string = 'min-size';

  @Input()
  sidebarToggled: boolean = false;
  @Output()
  sidebarToggledChange = new EventEmitter<boolean>();
  @Input()
  menuItemsTop: MenuItem[] = [];
  @Input()
  menuItemsBottom: MenuItem[] = [];

  transitionActive: boolean = false;

  constructor(public router: Router) {
  }

  ngAfterContentInit(): void {
    setTimeout(()=>this.transitionActive = true);

  }

  toggleFilterBarSize() {
    setTimeout(() => {
      this.sidebarToggled = !this.sidebarToggled;
      // this.filterToolbarClass = this.sidebarToggled?'max-size':'min-size';
      // console.log('-----> this.filterToolbarClass ' + this.filterToolbarClass);
      // @ts-ignore
      // this.tradeOrders.ngAfterViewInit();
      // window.dispatchEvent(new Event('resize'));
      this.sidebarToggledChange.emit(this.sidebarToggled);
    });
  }

}
